import React, { useEffect, useState } from "react";
import logo from "../../../assets/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { reduxLogout } from "../../../redux/Slices/authSlice";
const Header: React.FC = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const userData = useSelector((state: any) => state.auth.userData);

  // الروابط الموقع
  const menuItems = [
    { name: "الصفحة الرئسية", path: "/" },
    { name: "عن الشركه", path: "/AboutUs" },
    // { name: "الخدمات", path: "#" },
    // { name: "الخطوط", path: "Bus" },
    // { name: "حجوزاتى", path: "Bookings" },
    { name: "تواصل معنا", path: "/Contact" },
    { name: "لوحه التحكم", path: "/dashboard", isProtected: true },
  ];

  // فتح المنيو
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  // لتحويل لون الرابط
  const location = useLocation();
  const [activePath, setActivePath] = useState("/"); // المسار الافتراضي

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1]; // الحصول على المسار الحالي
    if (currentPath) {
      setActivePath(currentPath);
    }
  }, [location]);

  return (
    <header className="flex shadow-md sm:px-10 bg-white font-[sans-serif] min-h-[70px] tracking-wide z-50 fixed top-0 left-0 right-0 h-[70px]">
      <div className="flex flex-wrap items-center justify-between gap-2 w-full container">
        <Link to="/">
          <img src={logo} alt="logo" className="w-14" />
        </Link>

        <div
          className={`${
            isMenuOpen ? "block" : "hidden"
          } lg:block max-lg:before:fixed max-lg:before:bg-black max-lg:before:opacity-50 max-lg:before:inset-0 max-lg:before:z-50`}
        >
          <button
            onClick={toggleMenu}
            className="lg:hidden fixed top-2 right-4 z-[100] rounded-full bg-white p-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 fill-black"
              viewBox="0 0 320.591 320.591"
            >
              <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
              <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
            </svg>
          </button>

          <ul className="lg:flex lg:gap-x-3 xl:gap-x-5 max-lg:space-y-3 max-lg:fixed max-lg:bg-white max-lg:w-1/2 max-lg:min-w-[300px] max-lg:top-0 max-lg:left-0 max-lg:p-6 max-lg:h-full max-lg:shadow-md max-lg:overflow-auto z-50">
            <li className="mb-6 hidden max-lg:block">
              <a href="/">
                <img
                  src="https://readymadeui.com/readymadeui.svg"
                  alt="logo"
                  className="w-36"
                />
              </a>
            </li>
            {menuItems.map((item, index) => {
              if (item.isProtected && userData?.UserRole != 0) {
                return;
              }
              return (
                <li
                  key={index}
                  className="max-lg:border-b border-gray-300 max-lg:py-3 px-3"
                >
                  <Link
                    to={`${item.path}`}
                    className={`hover:text-[#007bff] ${
                      activePath === item.path
                        ? "text-[#007bff]"
                        : "text-gray-500"
                    } block font-semibold text-[15px]`}
                    onClick={() => {
                      setActivePath(item.path);
                      toggleMenu();
                    }}
                  >
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="flex gap-3">
          <div className="flex gap-3">
            {userData ? (
              <button
                onClick={() => {
                  dispatch(reduxLogout());
                  Navigate("/");
                }}
                className="px-4 py-2 text-sm rounded-full font-bold text-white border-2 border-[#007bff] bg-[#007bff] transition-all ease-in-out duration-300 hover:bg-transparent hover:text-[#007bff]"
              >
                تسجيل الخروج
              </button>
            ) : (
              <button
                onClick={() => Navigate("Login")}
                className="px-4 py-2 text-sm rounded-full font-bold text-white border-2 border-[#007bff] bg-[#007bff] transition-all ease-in-out duration-300 hover:bg-transparent hover:text-[#007bff]"
              >
                تسجيل الدخول
              </button>
            )}
          </div>

          <button onClick={toggleMenu} className="lg:hidden">
            <svg
              className="w-7 h-7"
              fill="#000"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
